
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M15.6.4l4.1 4.1c.4.4.4 1 0 1.4l-1.4 1.4-5.4-5.4L14.3.5c.3-.5.9-.5 1.3-.1zm1.3 8.1l-5.4-5.4L.9 13.7c-.2.2-.2.4-.3.6l-.5 4.6C0 19.5.5 20 1.2 20l4.6-.5c.2 0 .4-.1.6-.3L16.9 8.5z"}})])
          )
        }
      }
    